import { useMutation } from 'react-query'
import { postJSON } from 'common/services/api'
import { handleErrorResponse } from 'utils/error'
import { YEAR_FIRST_DATE_FORMAT } from 'screens/Rostering/utils.datetime'
import dayjs from 'dayjs'

export const GENERATE_ROTA_HISTORY_CSV_URL = 'rota-instances/export-history'

export const GENERATE_ROTA_UPCOMING_CSV_URL = 'rota-instances/export-rota'

export const useGenerateRotaCsv = (
  onSuccess?: () => void,
  isUpcoming?: boolean
) => {
  const mutationFunction = (
    body: Record<string, any>
  ): Promise<{ result: { message: string } }> => {
    const params = {
      startDate: dayjs(body?.dateRange[0]).utc().format(YEAR_FIRST_DATE_FORMAT),
      endDate: dayjs(body?.dateRange[1]).utc().format(YEAR_FIRST_DATE_FORMAT),
      serviceUsers: body?.serviceUsers,
      teamMembers: body?.teamMembers,
      createdBy: body?.createdBy,
      updatedBy: body?.serviceupdatedByUsers,
    }
    return postJSON({
      url: `${
        isUpcoming
          ? GENERATE_ROTA_UPCOMING_CSV_URL
          : GENERATE_ROTA_HISTORY_CSV_URL
      }`,
      method: 'POST',
      isRota: true,
      json: params,
      responseType: 'arrayBuffer',
    })
  }

  const { mutateAsync, isLoading, error } = useMutation(mutationFunction, {
    onSuccess,
  })

  return {
    isLoading,
    generate: mutateAsync,
    error: handleErrorResponse(error),
  }
}
